import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';
import dayjs from 'dayjs';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchObtenerPublicacion = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/comunicacion/obtenerBlog/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchPublicacionConvocatoriaFilters = async (paginaActual, registrosPorPag, busqueda, creador, editor, fechaInicio, fechaFin, ordenarColumna, orden) => {

    console.log("fechaInicio", fechaInicio);
    console.log("fechaFin", fechaFin);
    try {
        const response = await axios.post(`${API_URL}/api/comunicacion/obtenerBlog/filters`, {

            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "creador": creador,
            "editor": editor,
            "fechaInicio": fechaInicio ? dayjs(fechaInicio, "DD/MM/YYYY").format("YYYY-MM-DD") : null,
            "fechaFin": fechaFin ? dayjs(fechaFin, "DD/MM/YYYY").format("YYYY-MM-DD") : null,
            "order": {
                "orderColumn": ordenarColumna || "",
                "order": orden || ""
            }

        }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });


        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchCrearPublicacion = async (formData) => {
    console.log("formData", formData);
    try {
        const response = await axios.post(`${API_URL}/api/comunicacion/crearBlog`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });

        return response;
    } catch (error) {
        handleAuthError(error);
    }
};
export const fetchEditarPublicacion = async (formData) => {
    console.log("formData", formData);
    try {
        const response = await axios.put(`${API_URL}/api/comunicacion/editarBlog/${formData.IdPublicacion}`, formData, {

            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }

        });

        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchActualizarPublicaciones = async (ids, campoValor) => {
    console.log("campoValor", campoValor);
    try {
        const response = await axios.post(`${API_URL}/api/comunicacion/actualizarBlogsEnCadena`, {
            ids: ids,
            campo: campoValor.atributo,
            valor: campoValor.valor
        }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};
